import { useTranslation } from "react-i18next"
import { Pause, SkipForwardIcon } from "lucide-react"

import { Button } from "@/components/ui/button"
import { ButtonWithOptions } from "@/components/ui/button-with-options"
import {
  DropdownMenuGroup,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu"

type Props = {
  isDisabled?: boolean
  isLoading?: boolean
  onConfirmAndGoNext: () => void
  onConfirmAndGoOffline: () => void
}

export function CallPanelConfirmButton({
  isDisabled = false,
  isLoading = false,
  onConfirmAndGoNext,
  onConfirmAndGoOffline,
}: Props) {
  const { t } = useTranslation()

  return (
    <ButtonWithOptions
      isDisabled={isDisabled}
      isLoading={isLoading}
      mainActionButton={
        <Button
          onClick={onConfirmAndGoNext}
          className="rounded-none rounded-l"
          isDisabled={isDisabled}
          isLoading={isLoading}
        >
          <SkipForwardIcon className="size-6" />
          {t("global.button.confirmAndGoNext")}
        </Button>
      }
      dropdownMenuContent={
        <>
          <DropdownMenuGroup>
            <DropdownMenuItem
              onClick={onConfirmAndGoOffline}
              className="font-button-medium text-base"
            >
              <Pause className="mr-2 size-6" />
              {t("global.button.confirmAndGoOffline")}
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </>
      }
    />
  )
}
